import { Component } from '@angular/core';
import { SettingsService } from '@app/services/settings.service';

@Component({
  selector: 'app-error-403',
  templateUrl: './403.component.html',
  styleUrls: ['./403.component.scss'],
})
export class Error403Component {
  isDarkMode$ = this.settingsService.darkMode$;

  constructor(private settingsService: SettingsService) {}
}
